import apiRoutes from './local-api-routes';

let $searchFormationForm = $('#is-formation-search-form');
let $searchFormationSearchCtl = $('#is-formation-search-control');

export default {
  load() {

    if (!$searchFormationForm.length) {
      return;
    }

    $searchFormationSearchCtl
      .autocomplete({
        appendTo: '.results',
        source: function (request, response) {
          $.ajax({
            url: apiRoutes.generate('searchFormation'),
            data: {
              term: request.term,
            },
            success: function(data) {
              response(data);
            },
          });
        },
        minLength: 2,
        select: function (event, ui) {
          window.location.href = ui.item.link;
        },
      })
      .data('ui-autocomplete')._renderItem = function (ul, item) {
      // https://stackoverflow.com/questions/9887032/how-to-highlight-input-words-in-autocomplete-jquery-ui
      let newText = String(item.value).replace(
        new RegExp(this.term, 'gi'),
        '<span class="ui-state-highlight">$&</span>');

      return $('<li></li>')
        .data('ui-autocomplete-item', item)
        .append('<div class="name">' + newText + '</div>')
        .append('<div class="family-result">' + item.type + '</div>')
        .appendTo(ul);
    };

    // Pas de soumission de ce formulaire
    $searchFormationForm.submit(function (e) {
      e.preventDefault();
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/util/formationSearch.js